// Mock content for Restaurant Alfa landing page (frontend-only)
import {
  img_hero, img_gastraum, img_grill, img_table, img_ambiance, img_souvlaki, img_takeaway, img_quote
} from './assets';

export const RESTAURANT = {
  name: 'ALFA',
  place: 'HEIDECK',
  phone: '+49 9177 4852181',
  phoneHref: 'tel:+4991774852181',
  address: 'Hauptstraße 9, 91180 Heideck',
  mapsUrl: 'https://maps.google.com/?q=Hauptstra%C3%9Fe+9,+91180+Heideck',
  facebook: 'https://www.facebook.com/profile.php?id=61582090076511',
  facebookMessage: 'https://www.facebook.com/profile.php?id=61582090076511',
  instagram: 'https://www.instagram.com/alfaheideck',
  todayNote: 'Mo & Mi–So geöffnet · Di Ruhetag',
  email: 'alfaheideck@gmx.de',
};

export const IMPRESSUM = {
  company: 'Restaurant ALFA',
  owner: 'Nana Maysuradze',
  street: 'Hauptstraße 9',
  city: '91180 Heideck',
  country: 'Deutschland',
  phone: '09177 4852181',
  phoneHref: 'tel:+4991774852181',
  email: 'alfaheideck@gmx.de',
  vat: 'DE327562094',
};

export const NAV_LINKS = [
  { label: 'Ambiente', href: '#ambiente' },
  { label: 'Speisekarte', href: '#speisekarte' },
  { label: 'Gästestimmen', href: '#gaestestimmen' },
  { label: 'Kontakt', href: '#kontakt' },
];

export const MARQUEE_ITEMS = [
  'Gyros', 'Souvlaki', 'Lammhaxe', 'Kokinisto', 'Saganaki', 'Kalamari', 'Baklava', 'Ouzo',
];

export const IMAGES = {
  hero: img_hero,
  gastraum: img_gastraum,
  grill: img_grill,
  table: img_table,
  ambiance: img_ambiance,
  souvlaki: img_souvlaki,
  takeaway: img_takeaway,
  quote: img_quote,
};

export const STATS = [
  { value: '28. Nov. 2025', label: 'Eröffnung in der Hauptstraße 9' },
  { value: '6 Jahre', label: 'Gastgeber-Erfahrung aus Hilpoltstein' },
  { value: '100 %', label: 'Hausgemacht & frisch vom Grill' },
];

export const GALLERY = [
  { img: img_gastraum, caption: 'Der Gastraum' },
  { img: img_grill, caption: 'Frisch vom Grill' },
  { img: img_table, caption: 'Liebe zum Detail' },
];

export const MENU = [
  {
    category: 'Vorspeisen',
    items: [
      { name: 'Kleiner Appetitanreger', price: '9,50 €', desc: 'Mini Pita, Zaziki, Tarama, Schafskäse-Creme, Peperoni & Oliven' },
      { name: 'Dolmades', price: '10,20 €', desc: 'Hausgemachte Weinblätter mit Hackfleisch & Reis in Zitronensauce' },
      { name: 'Feta-Saganaki', price: '10,90 €', desc: 'Gebackener Schafskäse in knuspriger Panade' },
      { name: 'Gebackener Feta', price: '11,20 €', desc: 'Im Blätterteigmantel mit Honig, Sesam & Salat' },
      { name: 'Spanakopitakia', price: '10,50 €', desc: 'Blätterteigtaschen mit Käse & Spinat auf grünem Salat' },
      { name: 'Pikilia', price: '15,90 €', desc: 'Warme Vorspeisenplatte – auf Wunsch auch für mehrere Personen' },
    ],
  },
  {
    category: 'Salate',
    items: [
      { name: 'Bauernsalat', price: '12,50 €', desc: 'Nach griechischer Art mit Schafskäse & gegrilltem Pita-Brot' },
      { name: 'Gyros-Salatteller', price: '15,50 €', desc: 'Knuspriges Gyros, Zaziki, Pita-Brot & Joghurtdressing' },
      { name: 'Kreta-Salat', price: '18,60 €', desc: 'Gebackene Kalamari & Scampi mit Joghurtdressing' },
      { name: 'Fitness-Salat', price: '15,90 €', desc: 'Gegrillte Hühnerbrust mit Knoblauchcroutons' },
    ],
  },
  {
    category: 'Fleisch & Grill',
    items: [
      { name: 'Gyros-Teller', price: '16,50 €', desc: 'Mit Reis, Pommes, Zaziki & gemischtem Salat' },
      { name: 'Alfa Gyros', price: '17,50 €', desc: 'Mit Pita, Reis, Zaziki & gemischtem Salat' },
      { name: 'Souvlaki', price: '17,50 €', desc: 'Gegrillte Fleischspieße mit Tomatenreis & Zaziki' },
      { name: 'Bifteki-Spezial', price: '18,90 €', desc: 'Hacksteak mit Schafskäse gefüllt, Reis & Pommes' },
      { name: 'Bauernspieße', price: '20,90 €', desc: 'Filetspieße vom Schwein mit Tomatenreis & Zaziki' },
      { name: 'Milchlammkoteletts', price: '22,50 €', desc: 'Fünf Stück mit Tomatenreis, Pommes & Zaziki' },
      { name: 'Alfa-Platte für 2', price: '45,50 €', desc: 'Gyros, Kalamari, Scampi & Souvlaki mit Beilagen' },
      { name: 'Mazedonische Platte', price: '43,20 €', desc: 'Für 2 Personen, pikant gewürzt mit Metaxa-Sauce' },
    ],
  },
  {
    category: 'Gemischte Platten',
    items: [
      { name: 'Alfa-Teller', price: '17,90 €', desc: 'Gyros & Souvlaki' },
      { name: 'Dorf-Teller', price: '18,90 €', desc: 'Gyros, Souvlaki & Schweinesteak' },
      { name: 'Akropolis-Teller', price: '19,50 €', desc: 'Gyros, Souvlaki & Suzuki' },
      { name: 'Mykonos-Teller', price: '20,90 €', desc: 'Souvlaki, Gyros & Kalamari' },
      { name: 'Spezial-Teller', price: '21,70 €', desc: 'Filetspieß, Suzuki, Milchlammkotelett & Gyros' },
    ],
  },
  {
    category: 'Fisch & Meer',
    items: [
      { name: 'Kalamari', price: '19,90 €', desc: 'Gebacken mit Ofenkartoffeln, Zaziki & Salat' },
      { name: 'Scampi', price: '21,90 €', desc: 'Fünf Stück gegrillt auf Rucola mit Ofenkartoffeln' },
      { name: 'Lachsfilet vom Grill', price: '22,90 €', desc: 'Mit Zitronen-Olivenöl-Dressing & Grillgemüse' },
      { name: 'Samos-Teller', price: '20,90 €', desc: 'Scampi, Zungenfilet & Kalamari mit Zaziki' },
      { name: 'Ägäis-Platte', price: '42,90 €', desc: 'Fischvariation für 2 Personen' },
    ],
  },
  {
    category: 'Aus dem Backofen',
    items: [
      { name: 'Ofenfrische Lammhaxe', price: '21,90 €', desc: 'Mit Kritharaki überbacken oder Ofenkartoffeln & Salat' },
      { name: 'Kokinisto', price: '22,90 €', desc: 'Mit Kritharaki & Käse überbacken, dazu Salat' },
    ],
  },
  {
    category: 'Für kleine Gäste',
    items: [
      { name: 'Gyros', price: '10,90 €', desc: 'Mit Pommes frites & Zaziki' },
      { name: 'Souvlaki', price: '10,90 €', desc: 'Ein Spieß mit Pommes frites & Zaziki' },
      { name: 'Kleines Schnitzel', price: '10,90 €', desc: 'Vom Schwein, mit Pommes frites' },
    ],
  },
  {
    category: 'Süßer Abschluss',
    items: [
      { name: 'Galaktoboureko', price: '6,90 €', desc: 'Blätterteig mit feiner Milchcreme & Vanilleeis' },
      { name: 'Baklavas', price: '6,90 €', desc: 'Blätterteig mit Nüssen in Honigsirup & Vanilleeis' },
      { name: 'Griechischer Joghurt', price: '6,50 €', desc: 'Mit Honig & Walnüssen' },
      { name: 'Warmes Schokotörtchen', price: '6,90 €', desc: 'Mit flüssigem Kern, Vanilleeis & Sahne' },
      { name: 'Praliné Cookies', price: '7,50 €', desc: 'Schokocookies, Praliné-Schokolade & Vanillecreme' },
    ],
  },
];

export const MENU_NOTE = 'Auszug aus unserer Original-Speisekarte (Stand 02/2026) · Alle Preise in Euro inkl. MwSt. · Weine, Biere, Getränke & die komplette Karte erhalten Sie im Restaurant oder telefonisch.';

export const TESTIMONIALS = [
  { text: 'Ein absolutes Highlight in Heideck. Authentisches Essen und eine unfassbar gemütliche Steinwand-Atmosphäre.', name: 'Michael S.' },
  { text: 'Der beste Grillteller, den ich je gegessen habe. Das Fleisch auf den Punkt, das Ambiente luxuriös und doch warm.', name: 'Sarah K.' },
  { text: 'Wunderschönes Restaurant mit hervorragendem Service. Man fühlt sich wie im Urlaub am Mittelmeer.', name: 'Thomas W.' },
  { text: 'Endlich griechische Küche auf diesem Niveau in der Region. Das Saganaki ist ein Traum.', name: 'Anna L.' },
  { text: 'Sehr herzliche Gastgeber – man spürt die Erfahrung aus sechs Jahren in Hilpoltstein. Absolute Empfehlung!', name: 'Jürgen B.' },
  { text: 'Stilvolles Ambiente, faire Preise und ein Ouzo zum Abschied. Wir kommen ganz sicher wieder.', name: 'Petra M.' },
];

export const HOURS = [
  { day: 'Montag', time: '17:00 – 21:00', closed: false },
  { day: 'Dienstag', time: 'Geschlossen', closed: true },
  { day: 'Mittwoch', time: '17:00 – 21:00', closed: false },
  { day: 'Donnerstag', time: '17:00 – 21:00', closed: false },
  { day: 'Freitag', time: '17:00 – 22:00', closed: false },
  { day: 'Samstag', time: '17:00 – 23:00', closed: false },
  { day: 'Sonntag', time: '11:00 – 14:30 & 17:00 – 21:00', closed: false },
];
